import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2253b0e5/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Filter16 } from '@carbon/icons-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Tooltip`}</h2>
    <ComponentDemo links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/tooltip--default-bottom',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-tooltip--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvtooltip--default-interactive-tootlip',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=tooltip'
    }} mdxType="ComponentDemo">
  {`
  <Tooltip
    direction="bottom"
    tabIndex={0}
    triggerText="Tooltip label"
  >
    <p>
      This is some tooltip text. This box shows the maximum amount of text that should appear inside. If more room is needed please use a modal instead.
    </p>
    <div className="bx--tooltip__footer">
      <Link href="#">Learn More</Link>
      <Button size="small">
        Create
      </Button>
    </div>
  </Tooltip>
  `}
    </ComponentDemo>
    <h2>{`Icon tooltip`}</h2>
    <ComponentDemo scope={{
      Filter16
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/tooltipicon--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-tooltip-icon--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvtooltip--default-interactive-tootlip',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=tooltip'
    }} knobs={{
      TooltipIcon: ['direction', 'align']
    }} mdxType="ComponentDemo">
  {`
  <TooltipIcon
    tooltipText="Filter"
  >
    <Filter16/>
  </TooltipIcon>
  `}
    </ComponentDemo>
    <h2>{`Definition tooltip`}</h2>
    <ComponentDemo links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/tooltipdefinition--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-tooltip-definition--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvtooltip--minimal-definition-tootlip',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=tooltip'
    }} knobs={{
      TooltipDefinition: ['direction', 'align']
    }} mdxType="ComponentDemo">
  {`
  <TooltipDefinition
    tooltipText="Brief description of the dotted, underlined word above."
  >
    Definition Tooltip
  </TooltipDefinition>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      